import React, { useState, useEffect } from "react";
import { useDispatch, shallowEqual, useSelector } from "react-redux";
import { useParams, useHistory } from "react-router-dom";
import * as actions from "./_redux/Actions";
import { useSubheader } from "../../../_metronic/layout";
import { NotificationManager } from "react-notifications";
import {
  Card,
  CardBody,
  CardHeader,
  ModalProgressBar,
  Input2,
} from "../../../_metronic/_partials/controls";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";

import Upload from "../../components/upload/Upload";
import H5GamesSelectInput from "../../components/SelectComponents/H5GamesSelectInput";
import helperFunc from "../../../_metronic/_helpers/helperFunc";
import SearchSelectInput from "../../components/SelectComponents/SearchSelectInput";
import DropdownReactSelect from "../../components/DropdownReactSelect";

const CommonForm = (props) => {
  const suhbeader = useSubheader();
  const dispatch = useDispatch();
  const [title, setTitle] = useState("");
  const [file, setFile] = useState(undefined);
  const [wallImage, setWallImage] = useState(undefined);
  const [smallWallImage, setSmallWallImage] = useState(undefined);
  const { id } = useParams();
  let history = useHistory();
  const [
    companySelectedDropdownFilterData,
    setCompanySelectedDropdownFilterData,
  ] = useState(null);
  const [companyDropdownFilterData, setCompanyDropdownFilterData] = useState(
    []
  );
  const [
    countrySelectedDropdownFilterData,
    setCountryListDropdownFilterData,
  ] = useState();
  const [countryDropdownFilterData, setCountryDropdownFilterData] = useState();
  const [html5DropdownListData, setHtml5DropdownListData] = useState();
  const [selectedCompany, setSelectedCompany] = useState("");
  const [frmInitialValues, setFrmInitialValues] = useState({
    country: "",
    name: "",
    code: "",
    html5Category: "",
    description: "",
    url: "",
    thumbImageUrl: "",
    wallImageUrl: "",
    smallWallImageUrl: "",
    order: "",
    thumbImage: "",
    wallImage: "",
    smallWallImage: "",
    isActive: true,
    company: "GJ",
  });

  const { currentState } = useSelector(
    (state) => ({ currentState: state.H5Games }),
    shallowEqual
  );
  const {
    html5DropdownList,
    countryDropdownList,
    actionsLoading,
    H5GamesForEdit,
    company,
  } = currentState;
  useEffect(() => {
    dispatch(actions.fetchCompanyList());
  }, []);

  useEffect(() => {
    if(companySelectedDropdownFilterData?.code){
      dispatch(actions.fetchCountriesDropdownList({code:companySelectedDropdownFilterData?.value}))
    }
  }, [companySelectedDropdownFilterData]);

  useEffect(() => {
    if (
      companySelectedDropdownFilterData &&
      companySelectedDropdownFilterData?.code != null
    ) {
      console.log(companySelectedDropdownFilterData);
      dispatch(actions.fetchHTMLDropdownList({limit: 1000,page: 1,company: companySelectedDropdownFilterData?.code}));
    }
  }, [companySelectedDropdownFilterData]);


  useEffect(() => {
    let tempb = [];
    const userdata = JSON.parse(localStorage.getItem("userData"));
    const userCompany = userdata?.company || [];

    for (let i = 0; i < company.length; i++) {
      // if (!helperFunc.isAdmin()) {
      if (userCompany.includes(company[i]._id)) {
        let obj = {};
        obj.label = company[i].name;
        obj.value = company[i]._id;
        obj.code = company[i].code;
        tempb.push(obj);
      }
      // } else {
      //   let obj = {};
      //   obj.label = company[i].name;
      //   obj.value = company[i]._id;
      //   obj.code = company[i].code;
      //   tempb.push(obj);
      // }
    }

    setCompanyDropdownFilterData(tempb);
  }, [company]);
  useEffect(() => {
    dispatch(actions.fetchSingle(id));
  }, [id, dispatch]);
  const LevelsEditSchema = Yup.object().shape({
    name: Yup.string()
        .required("Name is required"),
    code: Yup.string()
        .required("Code is required"),
    url: Yup.string()
        .url("please enter correct URL")
        .required("url is required"),
    // thumbImageUrl: Yup.string()
    //     .url("please enter correct URL")
    //     .required("url is required"),
    // wallImageUrl: Yup.string()
    //     .url("please enter correct URL")
    //     .required("url is required"),
    // smallWallImageUrl: Yup.string()
    //     .url("please enter correct URL")
    //     .required("url is required"),
    order: Yup.number()
        .required("Order is required"),

});

  useEffect(() => {
    let _title = id ? "" : "New Html5 Game ";
    if (H5GamesForEdit && id) {
      const item = H5GamesForEdit.item==null ? H5GamesForEdit.data : H5GamesForEdit.item;

      _title = `Edit Html5 Game '${item &&
        item.name}'`;
      const data = { ...frmInitialValues, ...item };
      setFile(item && item.thumbImage);
      //   setCountryListDropdownFilterData({
      //     value: H5GamesForEdit?.item?.countries[0]?._id, // Assuming _id is the correct value for the dropdown
      //     label: H5GamesForEdit?.item?.countries[0]?.name,  // Display the country name in the dropdown
      // });

      var countriesArray = item?.countries.map((country) => ({
        value: country?._id,
        label: country?.name,
      }));
      //because or in some rows there are diffirent vaiables like country, or countries
      if (countriesArray === undefined || countriesArray.length === 0) {
        if (
          H5GamesForEdit?.country !== null &&
          typeof H5GamesForEdit?.country === "object"
        ) {
          countriesArray = [
            {
              value: H5GamesForEdit?.country?._id,
              label: H5GamesForEdit?.country?.name,
            },
          ];
        }
      }
      setCountryListDropdownFilterData(countriesArray);
      console.log("companyDropdownFilterData",companyDropdownFilterData);
      console.log("H5GamesForEdit",H5GamesForEdit);
      let cdtata = companyDropdownFilterData.filter((cd) =>
        cd.code.includes(H5GamesForEdit?.company.code)
      );
      console.log("cdtataFound",cdtata);
      //setHtml5DropdownListData();
      setCompanySelectedDropdownFilterData({
        value: cdtata[0]?.value, // Assuming _id is the correct value for the dropdown
        code: cdtata[0]?.code,
        label: cdtata[0]?.label,
      });

      setSelectedCompany({
        value: H5GamesForEdit.html5Category?._id, // Assuming _id is the correct value for the dropdown
        code: H5GamesForEdit.html5Category?.code,
        label: H5GamesForEdit.html5Category?.name,
      });
      setWallImage(item && item.wallImage);
      setSmallWallImage(item && item.smallWallImage);
      setFrmInitialValues(data);
    } else {
      setFile(undefined);
      setWallImage(undefined);
      setSmallWallImage(undefined);
    }
    setTitle(_title);
    suhbeader.setTitle(_title);
  }, [H5GamesForEdit, id]);

  useEffect(() => {
    if (countryDropdownList && countryDropdownList?.data) {
      let temp = [];
      countryDropdownList.data.forEach((element, i) => {
        temp.push({
          _id: i + 1,
          label: element.name,
          value: element._id,
        });
      });
      // console.log("temp:", temp);
      setCountryDropdownFilterData(temp);
    }
  }, [countryDropdownList]);

  useEffect(() => {
    if (html5DropdownList && html5DropdownList?.list) {
      let temp = [];
      html5DropdownList.list.forEach((element, i) => {
        temp.push({
          _id: i + 1,
          label: element.name,
          value: element._id,
        });
      });
      setHtml5DropdownListData(temp);
    }
  }, [html5DropdownList]);
  const onUpdateFileValue = (file, name) => {
    if (name === "thumbImage") {
      setFile(file.image);
    }
    if (name === "wallImage") {
      setWallImage(file.image);
    }
    if (name === "smallWallImage") {
      setSmallWallImage(file.image);
    }
    setFile(file.image);
  };
  // Function to handle form submission
  const saveLevel = async (values) => {
    const errors = [];

    // Validate each field
    if (!values.name) {
      errors.push("Name is required");
    }
    if (!values.description) {
      errors.push("Description is required");
    }
    if (!values.code) {
      errors.push("Code is required");
    }
    if (!values.url) {
      errors.push("URL is required");
    }

    if (!file) {
      errors.push("Please upload Thumb Image");
    }
    values.thumbImage = file;
    // if (!values.thumbImageUrl) {
    //   errors.push("Thumb Image URL is required");
    // }
    // if (!values.wallImageUrl) {
    //   errors.push("Wall Image URL is required");
    // }
    // if (!values.smallWallImageUrl) {
    //   errors.push("Small Wall Image URL is required");
    // }
    if (!values.order) {
      errors.push("Order is required");
    }
    if (!companySelectedDropdownFilterData) {
      errors.push("Please select a company");
    }

    if (
      !countrySelectedDropdownFilterData ||
      countrySelectedDropdownFilterData.length === 0
    ) {
      errors.push("Please select at least one country");
    }

    errors.forEach((error) => {
      NotificationManager.error(error, "Error");
    });

    // Check if there are errors
    if (errors.length > 0) {
      return;
    }

    // Set values for countryListArray
    const countryListArray = countrySelectedDropdownFilterData.map(
      (element) => element.value
    );
    values.countries = countryListArray;

    if (!file) {
      NotificationManager.error("Please upload Thumb Image", "Error");
      return;
    }
    values.thumbImage = file;
    values.wallImage = wallImage;
    values.smallWallImage = smallWallImage;

    // Set values for company
    console.log("companySelectedDropdownFilterData",companySelectedDropdownFilterData)
    if (companySelectedDropdownFilterData.length > 0) {
      values.company = companySelectedDropdownFilterData[0].code;
    }
    if (typeof companySelectedDropdownFilterData === 'object') {
      values.company = companySelectedDropdownFilterData.code;
    }

    // Set values for html5Category
    if (selectedCompany != null && selectedCompany?.value) {
      values.html5Category = selectedCompany?.value;
    } else {
      values.html5Category = html5DropdownListData[0].value;
    }

    // Dispatch actions based on whether it's a creation or update
    try {
      console.log("submit api call : ", values);
      // API call
      if (!id) {
        const success = await dispatch(actions.createItem(values));
        if (!success) {
          // If API call fails, do not redirect
          return;
        }
        // NotificationManager.success("Blog created successfully", "Success");
        setTimeout(backToList, 2000); // Navigate back if the API call was successful
      } else {
        const success = await dispatch(actions.updateItem(values));
        if (!success) {
          // If API call fails, do not redirect
          return;
        }
        // NotificationManager.success("Blog updated successfully", "Success");
        setTimeout(backToList, 2000);
        // Update item logic
      }
    } catch (error) {
      NotificationManager.error("Failed to save data", "Error");
    }
  };

  const backToList = () => {
    history.push(`/H5Games/list`);
    window.location.reload();
  };

  const companysListDropdownData = [
    {
      _id: "6133209fb2cdcb53a0cb7428",
      name: "Action",
      adjustName: "Action",
    },
    {
      _id: "64f9ab4448c1942613f4545f",
      name: "Game Test 3",
      adjustName: "Game GG",
    },
    {
      _id: "64f9acde48c1942613f4547b",
      name: "Aracde test",
      adjustName: "Arcade GG",
    },
    {
      _id: "64f9b1e5def32226ae953e66",
      name: "Arcade Categories",
      adjustName: "Arcade test",
    },
    {
      _id: "6502d5301c60f90e45e4c605",
      name: "test 12345",
    },
    {
      _id: "6502d5cc1c60f90e45e4c6ba",
      name: "Aracde",
      adjustName: "Game GG",
    },
    {
      _id: "6502dfe97416e90ff45d6978",
      name: "Arcade3",
      adjustName: "GG name",
    },
    {
      _id: "6502e2e92a12f2105294dfb1",
      name: "ludo king",
      adjustName: "GG name",
    },
  ];

  return (
    <Card>
      {actionsLoading && <ModalProgressBar />}
      <CardHeader title={title}></CardHeader>
      <CardBody>
        <Formik
          enableReinitialize={true}
          initialValues={frmInitialValues}
          onSubmit={(values) => {
            saveLevel(values);
          }}
        >
          {({ handleSubmit, values }) => (
            <Form className="form form-label-right">
              <div className="form-group row">
                <div className="col-lg-4 col-md-6 mt-4">
                  <label>
                    Select Company{" "}
                    <span style={{ color: "red", marginLeft: "3px" }}>*</span>
                  </label>
                  {console.log("testttt", frmInitialValues)}
                  <DropdownReactSelect
                    placeholder={"Select Company"}
                    name={"companies"}
                    value={
                      companySelectedDropdownFilterData ||
                      frmInitialValues?.company
                    }
                    isMulti={false}
                    isClearable={true}
                    isSearchable={true}
                    closeMenuOnSelect={true}
                    options={companyDropdownFilterData}
                    onChange={setCompanySelectedDropdownFilterData}
                  />
                </div>
                <div className="col-lg-4 col-md-6 mt-4">
                  <label>
                    Select Country{" "}
                    <span style={{ color: "red", marginLeft: "3px" }}>*</span>
                  </label>

                  <DropdownReactSelect
                    placeholder="Select Country"
                    name={"game"}
                    value={countrySelectedDropdownFilterData}
                    isMulti={true}
                    isClearable={true}
                    isSearchable={true}
                    closeMenuOnSelect={true}
                    options={countryDropdownFilterData}
                    onChange={setCountryListDropdownFilterData}
                    // isRequired={true}
                  />
                </div>
                <div className="col-lg-4 col-md-6 mt-4 ">
                  <Field
                    // className="form-controll"
                    name="name"
                    component={Input2}
                    placeholder="Name"
                    label="Name"
                    isRequired={true}
                  />
                </div>
                <div className="col-lg-4 col-md-6   mt-4">
                  <Field
                    // className="form-controll"
                    name="code"
                    component={Input2}
                    placeholder="Code"
                    label="Code"
                    isRequired={true}
                  />
                </div>
                <div className="col-lg-3 col-md-6  mt-4">
                  <label>Select HTML5 Category</label>
                  <DropdownReactSelect
                    placeholder="Select Category..."
                    name="company"
                    value={selectedCompany}
                    isMulti={false}
                    isClearable
                    isSearchable
                    closeMenuOnSelect
                    options={html5DropdownListData}
                    onChange={setSelectedCompany}
                  />
                </div>
                <div className="col-lg-4 col-md-6   mt-4">
                  <Field
                    // // className="form-controll"
                    name="description"
                    component={Input2}
                    type="textarea"
                    placeholder="Description"
                    label="Description"
                    isRequired={true}
                  />
                </div>
                <div className="col-lg-4 col-md-6   mt-4">
                  <Field
                    // className="form-controll"
                    name="url"
                    component={Input2}
                    placeholder="URL"
                    label="URL"
                    isRequired={true}
                  />
                </div>
                <div className="col-lg-3 col-md-6  mt-4">
                  <Field
                    // className="form-controll"
                    name="thumbImageUrl"
                    component={Input2}
                    placeholder="Thumb Image URL"
                    label="Thumb Image URL"
                  />
                </div>
                <div className="col-lg-4 col-md-6   mt-4">
                  <Field
                    // className="form-controll"
                    name="wallImageUrl"
                    component={Input2}
                    placeholder="Wall Image URL"
                    label="Wall Image URL"
                  />
                </div>
                <div className="col-lg-4 col-md-6   mt-4">
                  <Field
                    // className="form-controll"
                    name="smallWallImageUrl"
                    component={Input2}
                    placeholder="Small Wall Image URL"
                    label="Small Wall Image URL"
                  />
                </div>
                <div className="col-lg-2 col-md-6  mt-4">
                  <Field
                    // className="form-controll"
                    name="order"
                    component={Input2}
                    type="number"
                    placeholder="Order"
                    label="Order"
                    isRequired={true}
                  />
                </div>
                <div className="col-md-2">
                  <label className="col-form-label">Is Active</label>
                  <div className="col-12 w-100 p-0">
                    <span className="switch switch-primary switch-icon">
                      <label>
                        <Field type="checkbox" name="isActive" />
                        <span></span>
                      </label>
                    </span>
                  </div>
                </div>
              </div>
              <div className="form-group row">
                <div className="col-lg-4 col-md-6 ">
                  <Field
                    name="thumbImage"
                    component={Upload}
                    label="Thumb Image"
                    file={file}
                    onfileValueSet={onUpdateFileValue}
                    isRequired={true}
                  />
                </div>
                <div className="col-lg-4 col-md-6 ">
                  <Field
                    name="wallImage"
                    component={Upload}
                    label="Wall Image"
                    file={wallImage}
                    onfileValueSet={onUpdateFileValue}
                  />
                </div>
                <div className="col-lg-4 col-md-6 ">
                  <Field
                    name="smallWallImage"
                    component={Upload}
                    label="Small Wall Image"
                    file={smallWallImage}
                    onfileValueSet={onUpdateFileValue}
                  />
                </div>
              </div>
              <div className="form-group justify-content-end row mx-0">
                <button
                  type="button"
                  onClick={backToList}
                  className="btn btn-light"
                >
                  <i className="fa fa-arrow-left"></i>Back
                </button>
                <button type="submit" className="btn btn-primary ml-2">
                  {id ? "Update" : "Save"}
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </CardBody>
    </Card>
  );
};
export default CommonForm;
